import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Link,
  Typography,
} from "@common-ui/ui";
import { styled } from "@mui/material/styles";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import PersonIcon from "@mui/icons-material/Person";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import RestoreIcon from "@mui/icons-material/Restore";
import EditIcon from "@mui/icons-material/Edit";

import { ProfileImage } from "./ProfileImage";
import { useHistory } from "react-router";

const StyledBox = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  flexWrap: "wrap",
  marginRight: 5,
  marginLeft: 5,
});

const StyledGrid = styled(Grid)({
  justifyContent: "center",
  height: "70px",
  alignItems: "center",
  flexDirection: "column",
});

function getCityState(data) {
  let cityState = "--";
  const address = data?.street_address || data?.addresses;
  if (!Array.isArray(address)) {
    cityState = address?.city;
    if (address?.state_or_province)
      cityState += `, ${address?.state_or_province}`;
  } else {
    if (address.length > 0) {
      cityState = address[0]?.city;
      if (address[0]?.state_or_province)
        cityState += `, ${address[0]?.state_or_province}`;
    }
  }
  return cityState;
}

export const ProfileHeader = (props) => {
  const router = useHistory();
  const profileData = props?.data || {};
  const aggregateData = props?.profileCount || [];
  const email = profileData?.support_email || profileData?.email;
  const phone = profileData?.support_phone || profileData?.phone;
  const website = profileData?.website || "#";
  const facebook = profileData?.facebook || "#";
  const linkedin = profileData?.linkedin || "#";
  const youtube = profileData?.youtube || "#";
  const twitter = profileData?.twitter || "#";
  const membersCount = aggregateData[0]?.count + " " + aggregateData[0]?.label;
  const assetsCount = aggregateData[1]?.count + " " + aggregateData[1]?.label;
  const worksCount = aggregateData[2]?.count + " " + aggregateData[2]?.label;
  const placesCount = aggregateData[3]?.count + " " + aggregateData[3]?.label;

  return (
    <Box
      component="main"
      sx={{
        mb: "24px",
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
      }}
    >
      <Card sx={{ width: "100%", border: 0 }}>
        <CardContent>
          <Grid container spacing={1} alignItems="center">
            <Grid item>
              <ProfileImage data={profileData} />
            </Grid>
            <Grid item md={6} xs={6}>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                borderRight="1px solid #B3B3B3"
              >
                <Grid sx={{ marginLeft: "1rem" }} item>
                  <Typography
                    sx={{ mt: 1, position: "relative" }}
                    variant="h4"
                    fontWeight="700"
                  >
                    {profileData?.name}
                    <Box>
                      <Typography fontWeight="700" fontSize="0.7rem">
                        <LocationOnIcon
                          fontSize="small"
                          style={{ verticalAlign: "middle" }}
                          color="disabled"
                        />{" "}
                        {getCityState(profileData)}
                      </Typography>
                    </Box>
                    <IconButton
                      variant="text"
                      sx={{
                        position: "absolute",
                        right: "0",
                        top: "0",
                      }}
                      //   href={props.editLink}
                      onClick={() => router.push(`${props.editLink}`)}
                    >
                      <EditIcon
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />
                    </IconButton>
                  </Typography>
                </Grid>
                <Grid sx={{ margin: "1rem 0 1rem 1rem" }} item>
                  <StyledBox>
                    <Typography fontWeight="700" fontSize="0.7rem">
                      <EmailIcon
                        fontSize="small"
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />{" "}
                      {email != null ? (
                        <Link href={`mailto:${email}`} underline="none">
                          {email}
                        </Link>
                      ) : (
                        "--"
                      )}
                    </Typography>
                  </StyledBox>
                  <StyledBox>
                    <Typography fontWeight="700" fontSize="0.7rem">
                      <LanguageIcon
                        fontSize="small"
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />{" "}
                      {website != null ? (
                        <Link href={website} underline="none">
                          {website}
                        </Link>
                      ) : (
                        "--"
                      )}
                    </Typography>
                  </StyledBox>
                  <StyledBox>
                    <Typography fontWeight="700" fontSize="0.7rem">
                      <PhoneIphoneIcon
                        fontSize="small"
                        style={{ verticalAlign: "middle" }}
                        color="disabled"
                      />{" "}
                      {phone != null ? (
                        <Link href={`tel:${phone}`} underline="none">
                          {phone}
                        </Link>
                      ) : (
                        "--"
                      )}
                    </Typography>
                  </StyledBox>
                </Grid>
                <Grid item>
                  <StyledBox>
                    <IconButton href={facebook} target="_blank">
                      <Avatar>
                        <FacebookIcon fontSize="small" />
                      </Avatar>
                    </IconButton>
                    <IconButton href={linkedin} target="_blank">
                      <Avatar>
                        <LinkedInIcon fontSize="small" />
                      </Avatar>
                    </IconButton>
                    <IconButton href={youtube} target="_blank">
                      <Avatar>
                        <YouTubeIcon fontSize="small" />
                      </Avatar>
                    </IconButton>
                    <IconButton href={twitter} target="_blank">
                      <Avatar>
                        <TwitterIcon fontSize="small" />
                      </Avatar>
                    </IconButton>
                  </StyledBox>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item xs justifyContent="center">
              <StyledGrid container item xs={5}>
                <Avatar sx={{ bgcolor: "#BADBFF" }}>
                  <PersonIcon color="primary" fontSize="small" />
                </Avatar>
                <Typography variant="subtitle1" color="primary">
                  {membersCount}
                </Typography>
              </StyledGrid>
              <StyledGrid container item xs={5}>
                <Avatar sx={{ bgcolor: "#BADBFF" }}>
                  <FolderOpenIcon color="primary" fontSize="small" />
                </Avatar>
                <Typography variant="subtitle1" color="primary">
                  {assetsCount}
                </Typography>
              </StyledGrid>
              <StyledGrid container item xs={5}>
                <Avatar sx={{ bgcolor: "#BADBFF" }}>
                  <RestoreIcon color="primary" fontSize="small" />
                </Avatar>
                <Typography variant="subtitle1" color="primary">
                  {worksCount}
                </Typography>
              </StyledGrid>
              <StyledGrid container item xs={5}>
                <Avatar sx={{ bgcolor: "#BADBFF" }}>
                  <LocationOnIcon color="primary" fontSize="small" />
                </Avatar>
                <Typography variant="subtitle1" color="primary">
                  {placesCount}
                </Typography>
              </StyledGrid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};
